import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import { Editor } from 'slate-react';

import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { clearGlobalSelection } from '@utility/clearGlobalSelection';
import {
  ADD_MARK,
  INSERT_TEXT,
  REMOVE_MARK,
  SET_SELECTION,
} from '../../../../../../../../constants/selectionOpts';
import Schema from '../EditorSection/Schema';
import renderBlock from '../EditorSection/renderBlock';
import Actions from '../../../../../../../../store/actions';
import { TYPING_DEBOUNCE } from '../../../../../../../../constants/debounce';
import KEY_CODES from '../../../../../editJournal/constants/keyCodes';
import renderMark from '../../../../../editJournal/slateUtilities/renderMark';
import stopCommentExtension from '../../../../../../../../utility/commentExtension';
import CommentsCard from '../../../../../../../comments/commentsCard';
import resumePlugins from '../EditorSection/resumePlugins';
import { FormatTypes } from '../../../../../../../../constants/templateDictionaries';
import keyDown from '../EditorSection/utils/keyDown';
import paste from '../EditorSection/utils/paste';
import commentChange from '../EditorSection/commentChange';
import setMarksChange from './setMarksChange';
import setMarksOnBlur from '../EditorSection/setMarksOnBlur';
import SnackBarAlerts from '../../../../../../../common/snackBarAlerts/snackBarAlerts';
import breakpointsMinWidth from '../../../../../../../../styling/breakpointsMinWidth';
import { CHROME, SAFARI } from '../../../../../../../../utility/enums/browsers';
import { marksChange } from './basicInput';
import { fnBrowserDetect } from '../../../../../../../../utility/browsers';

const PhoneWrapper = styled.div`
  grid-column: 1/-1;

  width: -webkit-fill-available;
  width: 100%
  height: 40px;

  text-align: left;

  @media ${breakpointsMinWidth.tabletSm} {
    height: 36px;
    grid-column: 3/-1;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    grid-column: 4/-1;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    grid-column: ${(props) => (props.showImage ? '8/-1' : '7/-1')};
    
    height: 40px;
  }

  ${(props) => {
    const { componentKey } = props;

    if (componentKey === 'senderPhoneNumber') {
      return css`
        grid-column: 3/-1;
        @media ${breakpointsMinWidth.tabletSm} {
          height: 36px;
          grid-column: 3/-1;
        }
        @media ${breakpointsMinWidth.tabletLg} {
          grid-column: 3/-1;
        }
        @media ${breakpointsMinWidth.desktopMd} {
          grid-column: 3/-1;
          height: 40px;
        }
      `;
    }

    return null;
  }}
`;

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Input = styled.div`
  pointer-events: auto;
  height: 100%;
  width: 100%;
  position: relative;
`;

class Phone extends Component {
  constructor(props) {
    super(props);

    const { componentKey } = props;
    const { [componentKey]: value } = props;

    this.state = {
      value,
      showSnackBar: false,
      snackBarMessage: null,
      snackBarType: null,
    };
  }

  componentDidMount = () => {
    const { setInputEditorRef, setMarkType, componentKey } = this.props;
    setInputEditorRef(componentKey, this.editorRef);

    // Marks Setting it back to default
    setMarkType({
      bold: false,
      italic: false,
      underline: false,
    });
    const { editorRefs } = this.props;
    if (editorRefs) {
      const {
        value: {
          focusBlock,
          selection: { isFocused },
        },
      } = editorRefs[componentKey];
      const selections = editorRefs[componentKey];
      if (selections && focusBlock && isFocused) {
        selections?.deselect()?.blur();
      }
    }
  };

  componentDidUpdate = (prevProps) => {
    const { componentKey } = this.props;

    const {
      [componentKey]: { document: previousDocument },
    } = prevProps;

    const { [componentKey]: incomingSection } = this.props;
    const { document: currentDocument } = incomingSection;

    if (previousDocument !== currentDocument) {
      this.setState({ value: incomingSection });
      // this.setButtonState(incomingSection);
    }
  };

  componentWillUnmount = () => {
    if (fnBrowserDetect() === SAFARI) {
      clearGlobalSelection();
    }
  };

  onChange = ({ value, operations }) => {
    const {
      componentKey,
      bold,
      italic,
      underline,
      unorderedList,
      comment,
      setMarkType,
    } = this.props;

    const { document: currentDocument } = value;

    const {
      [componentKey]: { document: previousDocument },
      updateSection,
    } = this.props;

    const operationsArray = operations.toArray();

    const isComment = commentChange(operationsArray);

    let isSelectionOps = true;

    operationsArray.forEach((oper) => {
      if (
        oper.type !== SET_SELECTION &&
        !(oper.type === ADD_MARK && oper.mark.type === 'fakeSelection') &&
        !(oper.type === REMOVE_MARK && oper.mark.type === 'fakeSelection')
      )
        isSelectionOps = false;
    });

    if (isComment) isSelectionOps = false;

    /**
     * Debounce only when user types rest of the events
     * dispatch immediately
     */
    const debounce = operationsArray.some(
      (operation) => operation.type === INSERT_TEXT,
    );

    if (currentDocument !== previousDocument && !isSelectionOps) {
      clearTimeout(this.timer);
      if (debounce) {
        this.timer = setTimeout(
          () =>
            updateSection({
              updateType: 'component',
              key: componentKey,
              sectionKey: 'personalInfo',
              data: { value },
            }),
          TYPING_DEBOUNCE,
        );
      } else {
        updateSection({
          updateType: 'component',
          key: componentKey,
          sectionKey: 'personalInfo',
          data: { value },
        });
      }
    }
    this.setState({ value });
    if (isSelectionOps && value.selection.isFocused) {
      setTimeout(
        () =>
          setMarksChange({
            value,
            bold,
            italic,
            underline,
            unorderedList,
            comment,
            setMarkType,
          }),
        0,
      );
    }
  };

  onKeyDown = (event, editor, next) => {
    const {
      updatePopUpKeys,
      showCommentCard,
      showContextCard,
      formatType,
      componentKey,
      editorRefs,
    } = this.props;
    stopCommentExtension({
      editor: this.editorRef,
      showCommentCard,
      showContextCard,
      event,
      updatePopUpKeys,
    });

    const isPreventDefault = keyDown({
      componentKey,
      event,
      editor,
      formatType,
      editorRefs,
      updatePopUpKeys,
      showCommentCard,
      showContextCard,
    });
    if (isPreventDefault) return true;

    /**
     * Copy/Cut/Paste
     */
    const keyCodeSet = new Set([
      KEY_CODES.C,
      KEY_CODES.X,
      KEY_CODES.V,
      KEY_CODES.A,
      KEY_CODES.B,
      KEY_CODES.I,
      KEY_CODES.U,
    ]);

    if ((event.ctrlKey || event.metaKey) && keyCodeSet.has(event.which)) {
      return next();
    }

    /**
     * Should only accept numbers
     */
    if (
      (event.which !== 48 || !event.shiftKey) &&
      (event.which !== 57 || !event.shiftKey) &&
      (event.which < 48 || event.which > 57 || event.shiftKey) &&
      (event.which < 96 || event.which > 105) &&
      event.which !== 109 &&
      event.which !== KEY_CODES.BACKSPACE &&
      event.which !== KEY_CODES.DELETE &&
      event.which !== KEY_CODES.TAB &&
      event.which !== KEY_CODES.DOWN &&
      event.which !== KEY_CODES.UP &&
      event.which !== KEY_CODES.RIGHT &&
      event.which !== KEY_CODES.LEFT &&
      event.which !== KEY_CODES.SPACE &&
      (event.which !== KEY_CODES.HYPHEN || event.shiftKey) &&
      (event.which !== KEY_CODES.HYPHEN_FIREFOX || event.shiftKey)
    ) {
      event.preventDefault();
      return true;
    }
    return next();
  };

  renderMark = (...args) => {
    const argumentsData = args;
    const { formatType } = this.props;
    argumentsData[0].formatType = formatType;
    return renderMark(...argumentsData);
  };

  onPaste = (event, editor, next) => {
    const { formatType } = this.props;
    const isPreventDefault = paste({
      event,
      editor,
      formatType,
      setSnackBar: this.setSnackBar,
    });
    if (isPreventDefault) return;
    next();
  };

  onFocus = async (_event, editor) => {
    const { setInputEditorRef, componentKey } = this.props;
    const { value } = this.state;

    setInputEditorRef(componentKey);

    const resp = await marksChange({ value, ...this.props });
    // if (resp && fnBrowserDetect() !== CHROME) next();
    if (resp && fnBrowserDetect() !== CHROME) editor.focus();
  };

  onBlur = (_event, editor, next) => {
    const {
      setInputEditorRef,
      setMarkType,
      componentKey,
      bold,
      italic,
      underline,
      unorderedList,
      comment,
    } = this.props;
    setInputEditorRef();
    setTimeout(() => {
      setMarksOnBlur({
        componentKey,
        bold,
        italic,
        underline,
        unorderedList,
        comment,
        setMarkType,
      });
      editor.blur();
    }, 0);
    next();
  };

  renderBlock = (props, editor, next) => {
    const { formatType, setDateRef } = this.props;

    return renderBlock(props, editor, next, formatType, setDateRef);
  };

  handleClose = () => this.setState({ showSnackBar: false });

  setSnackBar = ({ snackBarMessage, snackBarType }) => {
    const { showSnackBar } = this.state;
    this.setState({
      snackBarMessage,
      snackBarType,
      showSnackBar: !showSnackBar,
    });
  };

  render() {
    const { value, showSnackBar, snackBarMessage, snackBarType } = this.state;
    const { componentKey, showImage } = this.props;

    const {
      showCommentCard,
      showContextCard,
      permission,
      saveDocument,
      formatType,
    } = this.props;

    let focusBlockType;
    const { focusBlock } = value;
    if (focusBlock) {
      const { type } = focusBlock;
      focusBlockType = type;
    }

    return (
      <>
        {showSnackBar && (
          <SnackBarAlerts
            snackBarMessage={snackBarMessage}
            snackBarType={snackBarType}
            showSnackBar={showSnackBar}
            handleClose={this.handleClose}
          />
        )}
        <PhoneWrapper showImage={showImage} componentKey={componentKey}>
          <InputWrapper>
            <Input>
              <Editor
                ref={(editor) => {
                  this.editorRef = editor;
                }}
                plugins={resumePlugins}
                schema={Schema[componentKey]}
                value={value}
                onChange={this.onChange}
                onBlur={this.onBlur}
                renderNode={this.renderBlock}
                renderMark={this.renderMark}
                onKeyDown={this.onKeyDown}
                onFocus={this.onFocus}
                onPaste={this.onPaste}
              />
              {focusBlock &&
                (focusBlockType === showCommentCard.focusBlockType ||
                  focusBlockType.includes(showCommentCard.focusBlockType) ||
                  focusBlockType === showContextCard.focusBlockType ||
                  focusBlockType.includes(showContextCard.focusBlockType)) && (
                  <CommentsCard
                    setSnackBarState={this.setSnackBarState}
                    permission={permission}
                    saveDocument={saveDocument}
                    editorRef={this.editorRef}
                    formatType={formatType}
                  />
                )}
            </Input>
          </InputWrapper>
        </PhoneWrapper>
      </>
    );
  }
}

Phone.propTypes = {
  componentKey: propTypes.string.isRequired,
  updateSection: propTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { componentKey, formatType } = ownProps;

  const common = {
    showCommentCard: state.commentsReducer.commentCard,
    showContextCard: state.commentsReducer.isContextMenu,
    bold: state.mostUsedToolsetReducer.marks.bold,
    italic: state.mostUsedToolsetReducer.marks.italic,
    underline: state.mostUsedToolsetReducer.marks.underline,
    unorderedList: state.mostUsedToolsetReducer.marks.unorderedList,
    comment: state.mostUsedToolsetReducer.marks.comment,
  };

  if (formatType === FormatTypes.RESUME) {
    return {
      [componentKey]: state.editResumeFormReducer[componentKey],
      ...common,
    };
  }

  if (formatType === FormatTypes.COVER_LETTER) {
    return {
      [componentKey]: state.editCoverLetterFormReducer[componentKey],
      ...common,
    };
  }

  return null;
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { formatType } = ownProps;

  const common = {
    updatePopUpKeys: (params) => {
      dispatch(Actions.commentActions.updatePopUpKeys(params));
    },
    setMarkType: (params) =>
      dispatch(Actions.mostUsedToolsetActions.setMarkType(params)),
  };

  if (formatType === FormatTypes.RESUME) {
    return {
      updateSection: (params) =>
        dispatch(Actions.editResumeFormActions.updateSection(params)),
      ...common,
    };
  }

  if (formatType === FormatTypes.COVER_LETTER) {
    return {
      updateSection: (params) =>
        dispatch(Actions.editCoverLetterFormActions.updateSection(params)),
      ...common,
    };
  }

  return null;
};

export default connect(mapStateToProps, mapDispatchToProps)(Phone);
